import React from 'react';
import styled from 'styled-components';
import RedfuseLogo from './redfuse-logo.png';

const RedfuseIcon = styled(props => <img src={RedfuseLogo} alt="redfuse icon" {...props} />)`
  height: 28px;
`;

export default RedfuseIcon;
